import $ from 'jquery';
import 'slick-carousel';
import Swipeable from '../components/Swipabable';

const testSlider = 'body-types-slider';
const $testSlider = $(`.${testSlider}`);

$testSlider.on('init beforeChange', function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $(`.controls-dots-${testSlider}`).data('theme');
    dots.addClass('slick-dot ' + theme);
  }
});

$testSlider.slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: false,
  dots: true,
  arrows: true,
  infinite: true,
  appendDots: $(`.controls-dots-${testSlider}`),
  nextArrow: $(`.controls-next-${testSlider}`),
  prevArrow: $(`.controls-prev-${testSlider}`),
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '8%',
      },
    },
  ],
});

let FIRST_CLASS = '';

$('.body-types-control').on('click', function () {
  FIRST_CLASS = '';

  const length = $(this).parents('.body-types-carousel-controls').data('length');
  const dir = $(this).attr('aria-label');
  const forward = dir == 'next';
  let $types = $('.body-carousel-type');

  if (!forward) {
    $types = $($('.body-carousel-type').get().reverse());
  }

  $types.each(function (index) {
    const $type = $(this);
    const typeIndex = $type.data('index');
    const currentClass = $type.attr('data-class');
    const first = index == 0;
    const last = index == length - 1;

    let $nextSlide = {};

    if (forward) {
      $nextSlide = $type.next();
      if (first) {
        FIRST_CLASS = currentClass;
      }
    } else {
      $nextSlide = $type.prev();
      if (first) {
        FIRST_CLASS = $(`.body-carousel-type[data-index="${length}"]`).attr('data-class');
      }
    }

    let nextClass = -1;
    if (forward) {
      nextClass = last ? FIRST_CLASS : $nextSlide.attr('data-class');
    } else {
      nextClass = last ? FIRST_CLASS : $nextSlide.attr('data-class');
    }

    $type.attr('data-class', nextClass);
    $type.removeClass(currentClass);
    $type.addClass(nextClass);

    const $typeContent = $(`.body-content[data-index="${typeIndex}"]`);
    $typeContent.removeClass(currentClass);
    $typeContent.addClass(nextClass);
  });
});

$('.body-types-carousel')
  .get()
  .forEach(function (elem, index) {
    //offset is preferably a number >= 2 && <= 10.
    const swipeable = new Swipeable({ offset: 50 });

    //example component: carousel//
    elem.addEventListener('touchstart', (e) => swipeable.touchStart(e));
    elem.addEventListener('touchmove', (e) => {
      swipeable.touchMove(e, {
        onLeft: (e, x) => triggerMove('prev', e, x),
        onRight: (e, x) => triggerMove('next', e, x),
      });
    });
    elem.addEventListener('touchend', (e) => swipeable.touchEnd(e));
  });

function triggerMove(dir, e, x) {
  // console.log(e, x);
  $(`.controls-${dir}`).trigger('click');
}
